import * as React from "react"

import { NavCalendar } from "@/components/nav-calendar"
import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarTrigger,
  useSidebar,
} from "@/components/ui/sidebar"

export function AppSidebar({ user, ui, calendar_events, ...props }) {
  const { toggleSidebar } = useSidebar()

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <div className="flex items-center gap-1 pt-2">
          <button
            type="button"
            onClick={toggleSidebar}
            aria-label="Toggle Sidebar"
            className="flex min-w-0 flex-1 px-3 group-data-[collapsible=icon]:hidden"
          >
            <img
              src="https://publicassets.teachme2.com/www/images/svg/logo-footer.svg"
              alt="TeachMe2"
              className="h-7 w-auto"
            />
          </button>
          <SidebarTrigger />
        </div>
      </SidebarHeader>
      <SidebarContent>
        <NavMain mainView={ui.main_view} />
      </SidebarContent>
      <SidebarFooter>
        <NavCalendar calendar_events={calendar_events} ui={ui.calendar_events} />
        <NavUser user={user} ui={ui} />
      </SidebarFooter>
    </Sidebar>
  )
}
